<div class="flex flex-col">
  <h4 class="font-bold">My primary CV</h4>
  @if (cv) {
    <cv-box-primary-cv [cv]="cv"></cv-box-primary-cv>
  }
  @if (!cv) {
    <mat-card appearance="outlined" class="flex flex-col">
      <mat-card-title>
        <h5 class="font-bold">You don't have any CV</h5>
      </mat-card-title>
      <mat-card-content>
        <p>
          To help your agent find best offers for you,
          <br />
          tell us about your professional experience.
        </p>
        <button
          class="small-button"
          color="accent"
          data-test-id="cv-box-create-cv-btn"
          mat-flat-button
          routerLink="/cv/wizard"
          type="button"
        >
          Create your CV
        </button>
      </mat-card-content>
    </mat-card>
  }
</div>
